import React from 'react';
import { RadioProps } from '@material-ui/core/Radio';

import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { Radio as MuiRadio } from '@material-ui/core';

const checked = <RadioButtonCheckedIcon />;
const unchecked = <RadioButtonUncheckedIcon />;
const Radio: React.FC<RadioProps> = props => {
  return <MuiRadio checkedIcon={checked} icon={unchecked} {...props} />;
};

export default Radio;
